import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { CheckIcon, CopyIcon } from "@radix-ui/react-icons";
import { Slot, Slottable } from "@radix-ui/themes";
export const CopyButton = React.forwardRef(function CopyButton({ value, asChild, children, style, ...props }, ref) {
    const [hasCopied, setHasCopied] = React.useState(false);
    const Comp = asChild ? Slot : "button";
    const timeoutRef = React.useRef();
    const handleClick = async () => {
        try {
            console.log("Copying text:", value);
            await navigator.clipboard.writeText(value);
            setHasCopied(true);
            // Clear any existing timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            // Set new timeout
            timeoutRef.current = setTimeout(() => {
                setHasCopied(false);
            }, 3000);
        }
        catch (err) {
            console.error("Failed to copy text:", err);
        }
    };
    // Cleanup timeout on unmount
    React.useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    return (_jsxs(Comp, { onPointerUp: handleClick, ref: ref, ...props, children: [hasCopied ? _jsx(CheckIcon, {}) : _jsx(CopyIcon, {}), _jsx(Slottable, { children: children })] }));
});
//# sourceMappingURL=copy-button.js.map